var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    style: _vm.modalStyles,
    attrs: {
      "name": "customCheckerboard",
      "width": "500px",
      "height": "614px",
      "adaptive": true,
      "scrollable": false,
      "click-to-close": false,
      "classes": ['generic-modals', 'v--modal', 'customs-tools', 'customcheckerboard', _vm.isMainApp ? 'customcheckerboard-is-main-app' : '']
    },
    on: {
      "before-open": _vm.setInitialData,
      "opened": _vm.opened,
      "closed": _vm.closed
    }
  }, [_c('section', {
    class: ['customs-tools', 'customcheckerboard-wrapper']
  }, [_c('customcheckerboard-top-nav', {
    attrs: {
      "is-main-app": _vm.isMainApp
    }
  }), _c('customcheckerboard-main-views', _vm._b({}, 'customcheckerboard-main-views', _vm.activeViewProperties, false)), _c('checkerboard-button-nav', {
    attrs: {
      "is-main-app": _vm.isMainApp
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }